import { SmartApplyFormSchemaValidator } from "../../domain/procedure/form-schema/smart-apply-form-schema-validator";

export const hasIgnorableValidationErrorsOnly = (
  validator: SmartApplyFormSchemaValidator,
): boolean => {
  const validationErrors = validator.validateDeep();
  const ignorableErrorsDetector: ((errorMessage: string) => boolean)[] = [];

  // あとから追加されたバリデーションにつき、いったん無視して実行する
  if (typeof validator.dateAndDateTimeFormat() === "string") {
    ignorableErrorsDetector.push(
      (errorMessage: string) =>
        errorMessage === validator.dateAndDateTimeFormat(),
    );
  }

  // コンポーネント増減の支障とならないので無視して実行する
  ignorableErrorsDetector.push(isCalcNotFoundError);
  ignorableErrorsDetector.push(isFileMaxSizeMissingError);
  ignorableErrorsDetector.push(isEnumOptionMissingError);
  ignorableErrorsDetector.push(isFileMaxSizeOverflowError);
  ignorableErrorsDetector.push(isTooLongLabelError);
  ignorableErrorsDetector.push(limitOverEnumCountError);
  ignorableErrorsDetector.push(maxOverMinError);

  // 以下、 staging 環境でのみ検出されたもの
  // いずれも申請者セクションにおけるコンポーネント増減の支障とならないので無視して実行する
  ignorableErrorsDetector.push(isTooLongSectionNameError);
  ignorableErrorsDetector.push(isTooLongDescriptionError);
  ignorableErrorsDetector.push(isTooLongSelectableOptionError);
  ignorableErrorsDetector.push(isTooManyRadioOptionsError);
  ignorableErrorsDetector.push(isTooManySelectOptionsError);
  ignorableErrorsDetector.push(isTooLargeRepeatableCountError);

  return validationErrors.every((errorMessage) =>
    ignorableErrorsDetector.some((detector) => detector(errorMessage)),
  );
};

const isCalcNotFoundError = (value: string): boolean => {
  return (
    /^数式「.*」は存在しません。別の数式を選択してください。$/.test(value) ||
    /^数式「.*」は存在しません。自動計算数式から数式を作成して、数式を選択し直してください。$/.test(
      value,
    )
  );
};

const isFileMaxSizeMissingError = (value: string): boolean => {
  return /^\[.*\]: ファイルサイズが未指定です$/.test(value);
};

const isEnumOptionMissingError = (value: string): boolean => {
  return /^\[.*\]: 選択肢は最低一つ必要です$/.test(value);
};

const isFileMaxSizeOverflowError = (value: string): boolean => {
  return /^\[.*\]: ファイルサイズは1MBから10MBの範囲で指定してください$/.test(
    value,
  );
};

const isTooLongLabelError = (value: string): boolean => {
  return /^\[.*\]: 項目名の長さは32文字以内で入力してください$/.test(value);
};

const limitOverEnumCountError = (value: string): boolean => {
  return /^\[.*\]: 選択肢の数である[0-9]{1,2}以下の数値を設定してください。$/.test(
    value,
  );
};
const maxOverMinError = (value: string): boolean => {
  return /^\[.*\]: 最[大小]値として設定されている[0-9]{1,2}以[上下]の数値を設定してください。$/.test(
    value,
  );
};

// 以下、 staging 環境でのみ検出されたもの

const isTooLongSectionNameError = (value: string): boolean => {
  return /^セクション名は32以下である必要があります$/.test(value);
};

const isTooLongDescriptionError = (value: string): boolean => {
  return /^\[.*\]: 200文字以内で入力してください$/.test(value);
};

const isTooLongSelectableOptionError = (value: string): boolean => {
  return /^\[.*\]: 選択肢に設定できる文字数は48文字以内で入力してください$/.test(
    value,
  );
};

const isTooManyRadioOptionsError = (value: string): boolean => {
  return /^\[.*\]: 選択肢の数は最大10個までです$/.test(value);
};

const isTooManySelectOptionsError = (value: string): boolean => {
  return /^\[.*\]: 選択肢の数は最大50個までです$/.test(value);
};

const isTooLargeRepeatableCountError = (value: string): boolean => {
  return /^\[.*\]: 繰り返し項目の最大繰り返し数は35以下に設定してください$/.test(
    value,
  );
};
